import { GridCustomCellProps, GridCustomRowProps, GridRowClickEvent, GridRowsSettings } from "@progress/kendo-react-grid";
import { useMemo } from "react";

import { useNavigate } from "react-router-dom";
import { IHomeTicket, ITicketListItem } from "../types/Ticket/Ticket";
import { IUserProfile } from "../types/User/User";
import { getTicketState } from "../util/getTicketState";
import { IHostConfig } from "../types/Tenant/IHostConfig";

export const CustomRowFormatter = (selectedTickets: ITicketListItem[], profile: IUserProfile, hostConfig: IHostConfig) => {

    const CustomRow = (props: GridCustomRowProps) => {
        let data = props.dataItem as ITicketListItem;
        //let selected = selectedTickets.some(ticket => ticket.Call_Id === data.Call_Id) ? 'k-selected' : '';

        let state = getTicketState({ homeTicket: data, newCallThresholdMins: hostConfig?.New_Call_Mins ?? 0, now: new Date() });
        let stateClass = "";
        switch (state) {
            case "New":
                stateClass = stateClass.concat(" green");
                break;
            case "Current":
                stateClass = stateClass.concat(" blue");
                break;
            case "Closed":
                stateClass = stateClass.concat(" purple");
                break;
            case "At Risk":
                stateClass = stateClass.concat(" yellow");
                break;
            case "Late":
                stateClass = stateClass.concat(" red");
                break;
            default:
                stateClass = stateClass.concat(" blue");
                break;
        }

        const navigate = useNavigate();
        const GridRow = useMemo(() => {


            return (
                <tr onClick={() => navigate(`/ticket/${data.Id}?from=Teams`)} {...props.trProps} className={`${props?.trProps?.className || ''} ${stateClass}`} key={`${data.Id}`}>
                    {props.children}
                </tr>
            );
        }, [data.Id]);

        return GridRow;
    };

    return {
        data: CustomRow,
    }
};
